<template>
  <div class="thumbnail-wrap">
    <received-badge
      v-if="showingReceivedBadge"
      v-tooltip="badgeTooltip"
    />
    <img
      class="object-cover w-full h-full rounded"
      v-if="presentation.thumbnailImage || presentation.customThumbnailImage"
      :src="getThumbnailUrl"
    >
    <img
      class="object-cover w-full h-full rounded"
      v-else
      src="@/assets/images/icon/default-thumbnail.svg"
    >
  </div>
</template>

<script>
import ReceivedBadge from './ReceivedBadge.vue'

// presentation.createdAt is always != presentation.updatedAt when duplicate prez
// So any update within created threshold is counted as "just received"
const JUST_RECEIVED_THRESHOLD = 30 * 1000

export default {
  components: {
    ReceivedBadge,
  },
  props: {
    presentation: {
      type: Object,
      default: null,
    },
  },
  computed: {
    badgeTooltip() {
      return `Just received from ${this.presentation.sender || 'your teammate'}`
    },

    // received badge will show when presentation is NOT yet edited
    // (meaning timeDiffMillisec is < threshold)
    showingReceivedBadge() {
      const timeDiffMillisec =
      new Date(this.presentation.createdAt) - new Date(this.presentation.updatedAt)
      return this.presentation.sender
        && Math.abs(timeDiffMillisec) < JUST_RECEIVED_THRESHOLD
    },
    getThumbnailUrl() {
      if (this.presentation.customThumbnailImage) {
        return this.presentation.customThumbnailImage
      }
      return this.presentation.thumbnailImage
    },
  },
}
</script>

<style>
  .thumbnail-wrap {
    @apply w-20 block cursor-pointer relative;
    height: 45px; /** using 16/9 aspect ratio, similar to default-thumbnail's aspect ratio */
  }
</style>
